import React, { useState, useContext, useEffect } from 'react'
import moment from 'moment'
import useCallbackOnTrue from 'lib/hooks/useCallbackOnTrue'
import { EVENT_FORM_MODE } from 'components/Events/EventForm/EventForm'
import { EVENT_TYPE } from 'lib/utils/store/event'

import { ExtendedFormikContext } from 'components/Forms/ExtendedFormik'
import { Field } from 'formik'
import EventFormModule from 'components/Events/EventForm/EventFormModules/EventFormModule'
import CompactFormRow from 'components/Forms/CompactForm/CompactFormRow/CompactFormRow'
import DateTimeInput from 'components/Forms/FormElements/DateTimeInput'
import Icon from 'components/Icon'

import './event-form-event-time-module.pcss'

const EventFormEventTimeModule = ({ label, name }) => {
    const { values, errors, setFieldTouched, validateField } = useContext(ExtendedFormikContext)
    const { formMode } = values

    const [open, setOpen] = useState(
        [EVENT_FORM_MODE.CREATE_REMINDER, EVENT_FORM_MODE.CONFIRM].includes(formMode)
    )

    const editable = values.type !== EVENT_TYPE.SYSTEM

    useCallbackOnTrue(errors[name], () => setOpen(true))

    useEffect(() => {
        if (formMode === EVENT_FORM_MODE.CONFIRM) {
            setFieldTouched(name)
            validateField(name)
        }
    }, [name, formMode, setFieldTouched, validateField])

    return (
        <EventFormModule className="event-form-event-time-module" expanded={open}>
            <CompactFormRow
                iconName="calendar-alt"
                label={label}
                onClick={() => editable && !open && setOpen(!open)}
                className="compact-form-date-row"
                trackName={name}
                expandable={editable && !open}
                editIcon={editable ? (
                    <Icon
                        fa
                        name="pen"
                        cssClass="icon--event-form"
                    />
                ) : null}
            >
                {!open && moment(values[name]).format('DD.MM.YYYY HH:mm')}
            </CompactFormRow>
            {(editable && open) && (
                <div>
                    <Field
                        name={name}
                        type="text"
                        dateFormat={false}
                    >
                        {(props) => (
                            <DateTimeInput
                                {...props}
                                size="s"
                                disablePastDates={formMode === EVENT_FORM_MODE.CREATE_REMINDER}
                                disableFutureDates={formMode === EVENT_FORM_MODE.CONFIRM}
                                disableSetCurrentTime={[
                                    EVENT_FORM_MODE.CREATE_REMINDER,
                                ].includes(formMode)}
                                initDisplaySetCurrentTime={![
                                    EVENT_FORM_MODE.CREATE_EVENT,
                                    EVENT_FORM_MODE.CREATE_REMINDER,
                                ].includes(formMode)}
                            />
                        )}
                    </Field>
                </div>
            )}
        </EventFormModule>
    )
}

export default EventFormEventTimeModule
